export const RETAILER_REFUSE_MODAL_OPEN = 'RETAILER_REFUSE_MODAL_OPEN';
export const RETAILER_REFUSE_MODAL_RESET = 'RETAILER_REFUSE_MODAL_RESET';
export const REFUSED_CONSUMER_UNIT = 'REFUSED_CONSUMER_UNIT';
export const REFUSED_SHARING_UNIT = 'REFUSED_SHARING_UNIT';
